<template>
  <default-template>
    <div class="right-spaced-template pt-3 pt-lg-5 px-lg-5 mx-lg-5 py-5">
      <div class="bg-gray-base ps-4 py-5 px-lg-5 mt-5">
        <div class="row w-100 m-0">
          <div class="col-xl-9 col-lg-7 p-0 order-1 order-lg-0">
            <slot />
          </div>
          <div class="col-xl-3 col-lg-5 order-0 order-lg-1">
            <div class="wrapper-dropdown ps-lg-3 mb-4 mb-lg-0">
              <div class="pt-lg-2">
                <h2 class="mb-0 text-center text-lg-start">
                  Olá, {{ user && user.name }}!
                </h2>
              </div>
              <div class="text-center text-lg-start mt-3 mb-4">
                <div class="badge gold" v-if="isPremium()">
                  <div class="star"></div>
                  <div class="ribbon">Assinatura<br />Premium</div>
                </div>
                <div class="badge silver" v-else-if="isLeitura()">
                  <div class="star"></div>
                  <div class="ribbon">Assinatura<br />Leitura</div>
                </div>
                <div class="badge bronze" v-else>
                  <div class="star"></div>
                  <div class="ribbon">Assinatura<br />Essencial</div>
                </div>
              </div>
              <p class="mt-4 text-center text-lg-start">Suas conquistas:</p>
              <div class="text-center text-lg-start mt-2 mb-4">
                <div class="badge blue">
                  <div class="circle">
                    <p class="numbers">{{ finishedBooks.length }}</p>
                  </div>
                  <div class="ribbon">Livros<br />Lidos</div>
                </div>
                <div class="badge orange">
                  <div class="circle">
                    <p class="numbers">
                      {{
                        completed_courses.filter(
                          (course) => parseFloat(course.grade) >= 7
                        ).length
                      }}
                    </p>
                  </div>
                  <div class="ribbon">Cursos<br />Finalizados</div>
                </div>
                <div class="badge green-dark">
                  <div class="circle">
                    <p class="numbers">{{ completed_videos.length }}</p>
                  </div>
                  <div class="ribbon">Vídeos<br />Assistidos</div>
                </div>
              </div>

              <div>
                <hr class="mt-4" />
              </div>
              <div class="d-none d-lg-block">
                <router-link
                  :to="{ name: 'my-profile' }"
                  class="btn ps-0 justify-content-start"
                  @click="$emit('click-menu')"
                >
                  Meu perfil
                </router-link>

                <router-link
                  :to="{ name: 'account' }"
                  class="btn ps-0 justify-content-start"
                  @click="$emit('click-menu')"
                >
                  Conta
                </router-link>

                <router-link
                  :to="{ name: 'signature' }"
                  class="btn ps-0 justify-content-start"
                  @click="$emit('click-menu')"
                >
                  Assinatura
                </router-link>

                <button
                  class="btn ps-0 justify-content-start w-100"
                  @click="logoutDialog = true"
                >
                  Sair
                </button>
              </div>
              <div class="d-lg-none">
                <div class="d-flex align-items-center justify-content-center">
                  <router-link
                    :to="{ name: 'my-profile' }"
                    class="btn ps-0 justify-content-start"
                    @click="$emit('click-menu')"
                  >
                    Meu perfil
                  </router-link>

                  <router-link
                    :to="{ name: 'account' }"
                    class="btn ps-0 justify-content-start"
                    @click="$emit('click-menu')"
                  >
                    Conta
                  </router-link>
                </div>
                <div class="d-flex align-items-center justify-content-center">
                  <router-link
                    :to="{ name: 'signature' }"
                    class="btn ps-0 justify-content-start"
                    @click="$emit('click-menu')"
                  >
                    Assinatura
                  </router-link>
                  <button
                    class="btn ps-0 justify-content-start"
                    @click="logoutDialog = true"
                  >
                    Sair
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <confirmation
          v-model="logoutDialog"
          title="Sair"
          text="Deseja mesmo sair?"
          @confirm="logout"
        />
      </div>
    </div>
  </default-template>
</template>

<script>
  import DefaultTemplate from "./DefaultTemplate.vue";
  import { mapState } from "vuex";

  export default {
    components: {
      DefaultTemplate,
    },
    data: () => ({
      logoutDialog: false,
      completed_videos: [],
      completed_courses: [],
      finishedBooks: [],
      libraryLoading: false,
    }),
    computed: {
      ...mapState("user", ["user"]),
    },
    watch: {
      user(newValue) {
        if (newValue && newValue.id) {
          this.dispatchCourses();
          this.dispatchLibrary();
        }
      },
    },
    methods: {
      logout() {
        this.$store.dispatch("logout").then(() => {
          this.$router.push({ name: "login" });
        });
      },
      isPremium() {
        const currentSignature =
          this.$store.state.user &&
          this.$store.state.user.user.current_signature
            ? this.$store.state.user.user.current_signature.id
            : 1;
        return [3, 4, 68, 69, 70].includes(currentSignature);
      },
      isLeitura() {
        const currentSignature =
          this.$store.state.user &&
          this.$store.state.user.user.current_signature
            ? this.$store.state.user.user.current_signature.id
            : 1;
        return [100, 101].includes(currentSignature);
      },
      async dispatchCompletedVideos() {
        this.$store.dispatch("courses/getAllCompletedLessons").then((data) => {
          this.completed_videos = data;
        });
      },
      async dispatchCompletedCourses() {
        this.$store
          .dispatch("courses/getCompletedCourses", this.user.id)
          .then((data) => {
            this.completed_courses = data;
          });
      },
      async dispatchLibraryFinished() {
        this.libraryLoading = true;
        this.finishedBooks = await this.$store.dispatch(
          "library/getFinishedLibrary",
          this.user.id
        );
        this.libraryLoading = false;
      },
      async dispatchVideos() {
        await this.dispatchCompletedVideos();
      },
      async dispatchCourses() {
        await this.dispatchCompletedCourses();
      },
      async dispatchLibrary() {
        await this.dispatchLibraryFinished();
      },
    },
    mounted() {
      if (this.user && this.user.id) {
        this.dispatchVideos();
        this.dispatchCourses();
        this.dispatchLibrary();
      }
    },
  };
</script>

<style lang="scss" scoped>
  .right-spaced-template {
    .btn {
      font-weight: 400;
      color: #fff;
    }
    .router-link-active,
    .router-link-exact-active {
      font-weight: 700;
      color: #63c98f;
    }

    .badge {
      position: relative;
      margin: 10px 28px;
      width: 41px;
      height: 57px;
      border-radius: 10px;
      display: inline-block;
      top: 0;
      transition: all 0.2s ease;
    }
    .badge:before,
    .badge:after {
      position: absolute;
      width: inherit;
      height: inherit;
      border-radius: inherit;
      background: inherit;
      content: "";
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
    }
    .badge:before {
      transform: rotate(60deg);
    }
    .badge:after {
      transform: rotate(-60deg);
    }
    .badge:hover {
      top: -4px;
    }
    .badge .circle {
      width: 30px;
      height: 30px;
      position: absolute;
      background: #fff;
      z-index: 1;
      border-radius: 50%;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
    }
    .badge .circle .numbers {
      font-size: 16px;
      padding: 8px 0 0 0;
      margin: 0;
    }
    .star {
      width: 30px;
      aspect-ratio: 1;
      z-index: 12;
      background: #ffffff;
      clip-path: polygon(
        50% 0,
        calc(50% * (1 + sin(0.4turn))) calc(50% * (1 - cos(0.4turn))),
        calc(50% * (1 - sin(0.2turn))) calc(50% * (1 - cos(0.2turn))),
        calc(50% * (1 + sin(0.2turn))) calc(50% * (1 - cos(0.2turn))),
        calc(50% * (1 - sin(0.4turn))) calc(50% * (1 - cos(0.4turn)))
      );
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
    }
    .badge .font {
      display: inline-block;
      margin-top: 1em;
    }
    .badge .ribbon {
      position: absolute;
      border-radius: 4px;
      padding: 5px 5px 5px;
      width: 85px;
      z-index: 2;
      color: #fff;
      bottom: -20px;
      left: 50%;
      margin-left: -43px;
      height: 30px;
      font-size: 11px;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.27);
      text-shadow: 0 2px 2px rgba(0, 0, 0, 0.1);
      text-transform: uppercase;
      background: linear-gradient(to bottom right, #555 0%, #333 100%);
      cursor: default;
      text-align: center;
    }
    .orange {
      background: linear-gradient(to bottom right, #ffc107 0%, #f57c00 100%);
    }
    .orange p {
      color: #f68401;
      font-family: "Comfortaa", sans-serif;
    }
    .blue {
      background: linear-gradient(to bottom right, #4fc3f7 0%, #2196f3 100%);
    }
    .blue p {
      color: #259af3;
      font-family: "Comfortaa", sans-serif;
    }
    .green-dark {
      background: linear-gradient(to bottom right, #4caf50 0%, #1b5e20 100%);
    }
    .green-dark p {
      color: #00944a;
    }
    .silver {
      background: linear-gradient(to bottom right, #e0e0e0 0%, #bdbdbd 100%);
    }
    .silver p {
      color: #9e9e9e;
    }
    .gold {
      background: linear-gradient(to bottom right, #e6ce6a 0%, #b7892b 100%);
    }
    .gold p {
      color: #b7892b;
    }
    .bronze {
      background: linear-gradient(to bottom right, #cd7f32 0%, #986634 100%);
    }
    .bronze p {
      color: #986634;
    }
  }
</style>
